import React, {useContext} from "react";
import { TextField } from '@mui/material';
import { AppContext } from "../../App";

export default function Promoter() {

  const { eventDetails, setEventDetails } = useContext(AppContext)

  const handleChange = (e) => {
    let clonedData = eventDetails
    clonedData['promoterDetails'][e.target.name] = e.target.value
    console.log(clonedData)
    setEventDetails(clonedData)
  }

  return(
    <div className="event-details">
      <h3 className="section-title">
        Promoter Details
      </h3>
      <div className="event-inputs">
        <TextField name="promoterName" sx={{marginBottom: 2}}  id="outlined-name" label="Promoter/ Company Name" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.promoterName} />
        <TextField name="promoterAddress" sx={{marginBottom: 2}}  id="outlined-name" label="Address" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.promoterAddress} />
        <TextField name="companyReg" sx={{marginBottom: 2}}  id="outlined-name" label="Company Reg. No." onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.companyReg} />
        <TextField name="vatNo" sx={{marginBottom: 2}}  id="outlined-name" label="VAT no." onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.vatNo} />
        <TextField name="companyContactPerson" sx={{marginBottom: 2}}  id="outlined-name" label="Contact Person" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.companyContactPerson} />
        <TextField name="companyContactNo" sx={{marginBottom: 2}}  id="outlined-name" label="Contact Number" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.companyContactNo} />
        <TextField name="promoterEmail" sx={{marginBottom: 2}}  id="outlined-name" label="Email Address" onChange={(e)=> handleChange(e)} defaultValue={eventDetails.promoterDetails.promoterEmail} />
      </div>
    </div>

  )
}

